import { AnalysisVirtualizedStepProps } from "@models/platform-analysis/entities/analysis";
import { FeatureAnalysisCollapseStateFilterLevel } from "@models/platform-analysis/enums/feature/featureAnalysisCollapseLevelFilter";
import { FeesDisplayMode } from "@models/platform-analysis/enums/fee/displayMode";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import {
  businessMetricAnalysisTableRowsSelectors,
  featureAnalysisTableRowsSelectors,
  feeAnalysisSmaTableRowsSelectors,
} from "@redux/slices/platform-analysis";
import { RootState } from "@redux/store";

export class AnalysisSaveFeatureSelectionTemplateConfigs {
  static readonly MaxTemplatesToDisplay = 20;
}

export class AnalysisMaxShortlistedConfigs {
  static readonly MaxProductsShortlistedAllowed = 5;
}

export const AnalysisVirtualizedTableStepConfigs: Partial<
  Record<AnalysisStep, AnalysisVirtualizedStepProps>
> = {
  [AnalysisStep.Feature]: {
    title: "Feature analysis",
    toolBarTitles: {
      default: "Feature analysis",
      review: "Feature review",
    },
    tableTitle: "Features",
    allowFilters: true,
    getSelectedProductsFunc: (state: RootState) =>
      state.platformAnalysis?.platformAnalysis?.feature?.all?.selectedProducts,
    getSelectedSubProductsFunc: () => undefined,
    getCurrentDataFunc: featureAnalysisTableRowsSelectors.selectAll,
    getCurrentCollapseLevelFunc: (state: RootState) =>
      state.platformAnalysis?.internal?.featureAnalysis?.collapseFilterLevel,
    getCollapseLevelChangedManuallyFunc: (state: RootState) =>
      state.platformAnalysis?.internal?.featureAnalysis
        ?.collapseStateChangedManually,
    shouldHideCollapseArrow: () => false,
    getHiddenColumnIndexesMapFunc: () => undefined,
  },
  [AnalysisStep.BusinessMetric]: {
    title: "Business metric review",
    toolBarTitles: {
      default: "Business metric analysis",
      review: "Business metric review",
    },
    tableTitle: "Business metrics",
    allowFilters: false,
    getSelectedProductsFunc: (state: RootState) =>
      state.platformAnalysis?.platformAnalysis?.businessMetric?.all
        ?.selectedProducts,
    getSelectedSubProductsFunc: () => undefined,
    getCurrentDataFunc: businessMetricAnalysisTableRowsSelectors.selectAll,
    getCurrentCollapseLevelFunc: () =>
      FeatureAnalysisCollapseStateFilterLevel.FeatureLevel,
    getCollapseLevelChangedManuallyFunc: () => false,
    shouldHideCollapseArrow: () => false,
    getHiddenColumnIndexesMapFunc: () => undefined,
  },
  [AnalysisStep.Fee]: {
    matchParentContainerWidth: true,
    title: "",
    tableTitle: "",
    removeToolbar: true,
    allowFilters: false,
    ignoreScrollBackToTopEvent: true,
    showSectionTooltip: true,
    showSubSectionTooltip: true,
    getSelectedProductsFunc: () => undefined,
    getSelectedSubProductsFunc: (state: RootState) =>
      state.platformAnalysis?.platformAnalysis?.fee?.smaPortfolioFee
        ?.selectedSubProducts,
    getCurrentDataFunc: feeAnalysisSmaTableRowsSelectors.selectAll,
    getCurrentCollapseLevelFunc: () =>
      FeatureAnalysisCollapseStateFilterLevel.FeatureLevel,
    getCollapseLevelChangedManuallyFunc: () => false,
    shouldHideCollapseArrow: (state: RootState) =>
      state.platformAnalysis?.internal?.feeAnalysis?.displayMode ===
      FeesDisplayMode.Summary,
    getHiddenColumnIndexesMapFunc: (state: RootState) =>
      state.platformAnalysis?.internal?.feeAnalysis?.hiddenIdsIndexMap || [],
  },
};
